import { currentUser } from 'js/utils/user';

import type { NavImpactPremiumBases, PremiumUpsells } from '../../types';

export type Segment = {
  source: string;
  url: string;
  copy: string;
  extra?: object;
  controlClickSource?: string;
};

function withQuery(base: string, params: Record<string, unknown>): string {
  const query = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return `${base}?${query}`;
}

export function segmentFor(
  bases: NavImpactPremiumBases,
  premiumUpsells?: PremiumUpsells,
  triggerOverride?: string,
): Segment | null {
  const churnedDiscount = premiumUpsells?.churnedUserReactivationDiscount;
  if (churnedDiscount) {
    return {
      source: 'reactivate_button',
      url: withQuery(bases.checkoutPath, {
        feature: 'churned_user_reactivation',
        trigger: triggerOverride ?? 'reactivate_button',
        from_navbar: true,
      }),
      copy:
        churnedDiscount.offer === 'discount'
          ? `Reactivate Premium, ${churnedDiscount.value} OFF`
          : `Reactivate Premium for ${churnedDiscount.value}`,
      extra: { offer: churnedDiscount.offer },
      controlClickSource: 'churned_user_reactivation_button',
    };
  }

  if (premiumUpsells?.trialPricingCopy) {
    return {
      source: 'nav-btn-trial',
      url: withQuery(bases.checkout, {
        feature: 'default',
        trigger: triggerOverride ?? 'nav-btn-trial',
        from_navbar: true,
      }),
      copy: premiumUpsells.trialPricingCopy,
    };
  }

  if (premiumUpsells?.reactivatePremiumUpsellType) {
    return {
      source: 'nav-btn-reactivate',
      url: withQuery(bases.checkout, {
        feature: 'default',
        trigger: triggerOverride ?? 'nav-btn-reactivate',
        premium_discount_coupon: premiumUpsells.halfOffCoupon,
        from_navbar: true,
      }),
      copy: 'Reactivate Premium 50% OFF',
    };
  }

  const newUserDiscount = premiumUpsells?.newUserDiscount;
  if (newUserDiscount) {
    if (currentUser?.created_at === undefined) {
      return null;
    }
    return {
      source: newUserDiscount.trigger,
      url: withQuery(bases.checkout, {
        feature: newUserDiscount.feature,
        trigger: triggerOverride ?? newUserDiscount.trigger,
        coupon_code: newUserDiscount.couponCode,
      }),
      copy: 'UPGRADE & GET 6 MONTHS FREE!',
    };
  }

  return {
    source: 'default',
    url: withQuery(bases.upgrade, {
      feature: 'default',
      trigger: triggerOverride ?? 'default',
      from_navbar: true,
    }),
    copy: 'Get Premium',
  };
}
